import apiClient from "./axios";



export const requestOtp = (phone) => {
   return apiClient.post('otp/send', { phone_number: phone });
}


export const verifyOtp = (payload) => {
   return apiClient.post('otp/check', payload);
}



export const checkUserExists = (phone) => {
   return apiClient.post('check-exists', { phone });
}

export const uploadPhoto = (photo) => {
   const formData = new FormData();
   formData.append('photo', photo);
   return apiClient.post('upload-photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
   });
};

export const register = (payload) => {
   return apiClient.post('register', payload);
}

export const storePhone = (phone) => {
   return apiClient.post('/registration/phone', { phone_number: phone });
}

export const storePhoto = (photo, type) => {
   const formData = new FormData();
   formData.append('photo', photo);
   formData.append('type', type);

   return apiClient.post('/registration/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
   });

}

export const store = (payload) => {
   console.log('payload :>> ', payload);
   return apiClient.post('/registration/data', payload);
}